module.exports = __webpack_public_path__ + "img/1 (30).6688619d.png";